
import { useMediaQuery } from "react-responsive";

const useResponsive = ({ maxWidth } = { maxWidth: 768 }) => {
  const isMobile = useMediaQuery({ query: `(max-width: ${maxWidth}px)` });

  return { isMobile };
};

export default useResponsive;
